import CommonInterface from './commonInterface';
export default class BaseService extends CommonInterface {
    constructor() {
        super();
    }
    $log(service, message) {
        console.log(`%c[${service}]%c `, 'color:green;', 'color:white;', message);
    }
}
